import Header from "../../../../layouts/Header";
import LoginComponent from "../../../../components/login"

const ForgotPassword = () => {
  return (
    <div>
      <Header />
      <div className="hero min-h-screen bg-base-200">
        <div className="hero-content flex-col lg:flex-row-reverse">
          <div className="text-center lg:text-left">
            <h1 className="text-5xl font-bold">Forgot Password?</h1>
            <p className="py-6 w-96">Enter your email address!</p>
          </div>
          <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
            <div className="card-body">
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Email</span>
                </label>
                <input
                  type="text"
                  placeholder="email "
                  className="input input-bordered"
                />
              </div>
              <div className="form-control mt-6">
                <button className="btn btn-primary">Enter</button>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
